export default "__VITE_ASSET__MkgE7GLm__"